var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenGraphL(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 48,
    viewBox: "0 0 95 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.92859 22.1705C6.6873 18.3557 9.35531 16.2169 14.114 12.4021C18.8727 8.58736 26.2923 22.6079 35.4385 22.1705C43.7296 21.774 46.1645 13.9181 54.3259 12.4021C59.4728 11.4461 62.6744 13.7623 67.7299 12.4021C74.4884 10.5838 75.5548 3.68876 82.3524 2.02325C86.7438 0.947291 93.9286 2.02325 93.9286 2.02325",
    stroke: "#4AF06F",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.114 14.2644L1.92859 24.161V47.9749H93.9286V3.74913C93.9286 3.74913 86.7438 2.65904 82.3524 3.74913C75.5548 5.43653 74.4884 12.4222 67.7299 14.2644C62.6744 15.6423 59.4728 13.2958 54.3259 14.2644C46.1645 15.8002 43.7296 23.7593 35.4385 24.161C26.2923 24.6042 18.8727 10.3995 14.114 14.2644Z",
    fill: "url(#paint0_linear_193_725)",
    fillOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_193_725",
    x1: 47.9286,
    y1: 3.26465,
    x2: 47.9286,
    y2: 47.9749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.291667,
    stopColor: "#EEFDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822917,
    stopColor: "#EEFDF4",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenGraphL);
export default __webpack_public_path__ + "static/media/greenGraphL.fa83fb584241bdac11ab1cd049ca0689.svg";
export { ForwardRef as ReactComponent };